// src/components/PracticeTest/Breadcrumb.jsx



import React from 'react';

export default function Breadcrumb({ currentView, activeCategory, onBack }) {
  return (
    <nav className="breadcrumb">
      <span 
        className={currentView === 'posts' ? 'clickable' : 'active'} 
        onClick={onBack}
      >
        Folders
      </span>
      
      {currentView === 'posts' && activeCategory && (
        <>
          <span className="separator">/</span>
          <span className="active">{activeCategory}</span>
        </>
      )}
    </nav>
  );
}